module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "flex justify-between items-center px-2 py-2.5 z-10 bg-white"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('img', {
    staticClass: "avatar mr-2 w-7 h-7 rounded-full",
    attrs: {
      "src": "/static/roundtable_options_create/genie_icon.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col font-manrope"
  }, [_c('span', {
    staticClass: "font-semibold leading-4"
  }, [_vm._v(" Follow-Up Questions ")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-500 leading-3"
  }, [_vm._v("\n          " + _vm._s(_vm.recapDateTimeAgo) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-1"
  }, [(_vm.recapQuestions.length) ? _c('div', [_c('Tooltip', {
    attrs: {
      "text": "Edit Follow-Up Questions",
      "styleTooltip": "top-0 right-full mr-2",
      "backgroundColor": "bg-gray-700"
    }
  }, [_c('button', {
    staticClass: "sample hover:bg-gray-100 text-gray-600 rounded-full w-8 h-8",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.editFollowUpQuestions
    }
  }, [_c('i', {
    staticClass: "fa-regular fa-pen-to-square"
  })])])], 1) : _vm._e(), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": "Regenerate Follow-Up Questions",
      "styleTooltip": "top-0 right-full mr-2",
      "backgroundColor": "bg-gray-700"
    }
  }, [_c('button', {
    staticClass: "sample flex justify-center hover:bg-pink-100 text-pinky items-center rounded-full w-8 h-8",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.regenerateFollowUpQuestions
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-rotate",
    class: _vm.loading ? 'animate-spin' : ''
  })])]), _vm._v(" "), _c('button', {
    staticClass: "flex justify-center items-center hover:bg-gray-100 w-8 text-gray-600 h-8 rounded-full",
    on: {
      "click": function($event) {
        return _vm.$emit('backToOnlineStudentList')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-close text-base"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "px-2.5 pt-2 pb-6 max-height-list"
  }, [_c('div', [_c('ul', {
    staticClass: "space-y-2"
  }, _vm._l((_vm.recapQuestions), function(q, index) {
    return _c('li', {
      key: index,
      staticClass: "flex items-start gap-3 font-manrope rounded-lg cursor-pointer transition-colors duration-200"
    }, [_c('span', [_vm._v("\n            " + _vm._s(index + 1) + ".\n          ")]), _vm._v(" "), _c('p', {
      staticClass: "text-gray-700 leading-snug"
    }, [_vm._v("\n            " + _vm._s(q.question) + "\n          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('button', {
    staticClass: "sample px-5 py-3.5 border border-gray-200 hover:bg-gray-50 text-left border-solid rounded-lg font-manrope cursor-pointer disabled:opacity-60",
    class: _vm.loading || _vm.genieRecap.is_current_rt ? '' : 'hover:border-gray-300',
    attrs: {
      "disabled": _vm.loading || _vm.genieRecap.is_current_rt
    },
    on: {
      "click": _vm.addQuestionCurrentRT
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('button', {
    staticClass: "px-5 py-3.5 border hover:border-gray-300 text-left hover:bg-gray-50 border-gray-200 border-solid rounded-lg font-manrope cursor-pointer disabled:opacity-60",
    attrs: {
      "disabled": _vm.loading,
      "id": "written-roundtable-follow-up"
    },
    on: {
      "click": _vm.startFollowUpWRT
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('button', {
    staticClass: "px-5 py-3.5 border hover:border-gray-300 hover:bg-gray-50 border-solid text-left border-gray-200 rounded-lg font-manrope cursor-pointer disabled:opacity-60",
    attrs: {
      "disabled": _vm.loading,
      "id": "verbal-roundtable-follow-up"
    },
    on: {
      "click": _vm.startFollowUpVRT
    }
  }, [_vm._m(3)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col mb-6"
  }, [_c('h6', {
    staticClass: "font-semibold mb-1 text-gray-700 font-manrope"
  }, [_vm._v("\n            Share Follow-Up Questions\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs font-manrope text-gray-600"
  }, [_vm._v("\n            Click below to share these follow-up questions with your students.\n            You can edit the questions.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-4"
  }, [_c('img', {
    staticClass: "w-8 h-8",
    attrs: {
      "src": "/static/roundtable_options_create/current_roundtable_icon.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('h6', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Current RoundTable")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400"
  }, [_vm._v("\n                  Students can comment one the Genie Recap thread\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-center rounded-full h-8 w-8 bg-blue"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/written_icon.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('h6', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Written RoundTable")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400"
  }, [_vm._v("\n                  Create a new Written RoundTable for the class\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-center rounded-full h-8 w-8 bg-green-light"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/verbal_icon.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('h6', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Verbal RoundTable")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400"
  }, [_vm._v("\n                  Create a new Verbal RoundTable for the class\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3cb551c1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/genieRecap/genieRecapSideBar.vue
// module id = 1272
// module chunks = 61